var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"panel"}},[_c('div',{attrs:{"id":"dragIcon"}}),_vm._v(" "),_c('div',{attrs:{"id":"myicon"}},[_c('Icon',{attrs:{"type":_vm.isFull ? 'ios-arrow-up' : 'ios-arrow-down'},on:{"click":_vm.puMan}}),_vm._v(" "),_c('Icon',{attrs:{"type":"md-close"},on:{"click":_vm.close}})],1),_vm._v(" "),_vm._t("default",null,{"mydata":_vm.height})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4057fa92","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/locus/drag.vue
// module id = null
// module chunks = 